import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import Button from "../../shared/Button";

const ReportLedger = ({
  printInfo,
  students,
  subjects,
  reportValues,
  isPercent,
  assessmentId,
}) => {
  const componentRef = useRef();

  const printFunction = useReactToPrint({
    content: () => componentRef.current,
    orientation: "landscape",
    removeAfterPrint: true,
    documentTitle: `report_ledger_${printInfo?.yearLeveName}_${printInfo?.classroomName}`,
    pageStyle: "a4",
    layout: "A4",
  });

  return (
    <>
      <Button
        disabled={!assessmentId}
        variant="outline"
        onClick={(e) => printFunction()}
      >
        Print Ledger
      </Button>

      <div className="arr-report-ledger" style={{ display: "none" }}>
        <div className="landscape" id="printRoutine" ref={componentRef}>
          <div className="print-header my-2 text-center">
            <p className="mb-0">
              {printInfo?.yearLeveName}, {printInfo?.classroomName}
            </p>
            {/* <br/> */}
            <p className="mb-0">{printInfo?.assessmentName}</p>
            {/* <br/> */}
            <p className="mb-0">Mark Ledger</p>
          </div>
          <table className="table table-bordered table-striped report-ledger">
            <thead>
              <tr>
                <th rowSpan={2}>S.No.</th>
                <th rowSpan={2}>Student Name</th>
                <th rowSpan={2}>Symbol No.</th>
                {subjects?.map((item) => (
                  <th
                    colSpan={
                      Number(item?.hasTheory) + Number(item?.hasPractical) + 1
                    }
                    key={item?.subjectName}
                  >
                    {item?.subjectName}
                  </th>
                ))}
                <th colSpan={isPercent ? 5 : 3}>
                  <div
                    style={{
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                    className="flex"
                  >
                    <p>Result Information</p>
                  </div>
                </th>
              </tr>
              <tr>
                {subjects?.map((item) => {
                  if (item?.hasTheory && item?.hasPractical) {
                    return (
                      <React.Fragment key={item?.subjectId}>
                        <th>TH</th>
                        <th>PR</th>
                        <th>Tot</th>
                      </React.Fragment>
                    );
                  }
                  if (item?.hasTheory && !item?.hasPractical) {
                    return (
                      <React.Fragment key={item?.subjectId}>
                        <th>TH</th>
                        <th>Tot</th>
                      </React.Fragment>
                    );
                  }
                  if (!item?.hasTheory && item?.hasPractical) {
                    return (
                      <React.Fragment key={item?.subjectId}>
                        <th>PR</th>
                        <th>Tot</th>
                      </React.Fragment>
                    );
                  }
                })}
                <th>Total Obtained</th>
                <th>Rank</th>
                {!isPercent ? (
                  <th>GPA</th>
                ) : (
                  <>
                    <th>Percent</th>
                    <th>Result</th>
                    <th>Division</th>
                  </>
                )}
              </tr>
            </thead>
            <tbody>
              {students?.map((student, index) => {
                //get marks for every subject
                const getSubjectMarks = (subjectId) => {
                  const studentSubject = student.subjects.find(
                    (sub) => sub.id === subjectId,
                  );

                  return studentSubject?.studentSubjectAssessment || {};
                };

                const studentReportValues = reportValues?.filter(
                  (item) => item.admissionId === student.id,
                )[0];

                return (
                  <tr key={student?.id}>
                    <td>{index + 1}</td>
                    <td>{student?.people?.name}</td>
                    <td>
                      {student?.symbolNo ?? student?.people?.symbolNo ?? "-"}
                    </td>
                    {subjects?.map((subject) => {
                      const marks = getSubjectMarks(subject.subjectId);

                      const theoryMark = marks.isTheoryAbsent
                        ? "Ab"
                        : (marks.theoryObtainedMarks ?? "-");
                      const practicalMark = marks.isPracticalAbsent
                        ? "Ab"
                        : (marks.practicalObtainedMarks ?? "-");
                      const totalMark =
                        marks.isTheoryAbsent || marks.isPracticalAbsent
                          ? "Ab"
                          : (marks.obtainedMarks ?? "-");
                      return (
                        <React.Fragment key={subject.subjectId}>
                          {subject?.hasTheory && (
                            <td className="text-center">{theoryMark}</td>
                          )}
                          {subject?.hasPractical && (
                            <td className="text-center">{practicalMark}</td>
                          )}
                          <td className="text-center">{totalMark}</td>
                        </React.Fragment>
                      );
                    })}
                    <td style={{ textAlign: "center" }}>
                      {studentReportValues?.values?.obtainedMarks ?? "-"}
                    </td>
                    <td style={{ textAlign: "center" }}>
                      {studentReportValues?.values?.rank ?? "-"}
                    </td>
                    {isPercent ? (
                      <>
                        <td style={{ textAlign: "center" }}>
                          {Math.round(
                            studentReportValues?.values?.percent * 10,
                          ) / 10 || "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {studentReportValues?.values?.result ?? "-"}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {studentReportValues?.values?.division ?? "-"}
                        </td>
                      </>
                    ) : (
                      <>
                        <td style={{ textAlign: "center" }}>
                          {studentReportValues?.values?.finalGrade ?? "-"}
                        </td>
                      </>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default ReportLedger;
